import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { SaleConfigurationRepository } from './domain/SaleConfigurationRepository'

import { SaleConfiguration } from '../../contracts/appointment/saleConfiguration'
import { AxiosErrorHandler } from '../../foundation'

export class PartnerApiSaleConfiguration implements SaleConfigurationRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getConfig = async (serviceOfferId: number): Promise<SaleConfiguration> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: `partner/appointments/sale-configurations/service-offers/${serviceOfferId}`,
      method: 'get',
    }

    try {
      const { data } = await this.axios.request<SaleConfiguration>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  updateConfig = async (serviceOfferId: number, saleAvailability: boolean): Promise<SaleConfiguration> => {
    const config: AxiosRequestConfig<{ serviceOfferId: number; saleAvailability: boolean }> = {
      url: `partner/appointments/sale-configurations/commands/update-sale-configuration`,
      method: 'post',
      data: { serviceOfferId, saleAvailability },
    }

    try {
      const { data } = await this.axios.request<SaleConfiguration>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
